"use strict";

import React from "react";
import UIActions from "../actions/UIActions";

class WorkInProgressOverlay extends React.Component {
  _removeOverlay = (e) => {
    if (e.shiftKey && e.altKey) {
      UIActions.toggleWorkingOverlay({ working: false });
    }
  };

  render() {
    const style = {
      fontSize: 24,
      textAlign: "center",
      backgroundColor: "rgba(0,0,0,.5)",
      zIndex: 10000,
    };

    return (
      <div style={style} className={"view-centered"} onDoubleClick={this._removeOverlay}>
        <div>{this.props.message}</div>
      </div>
    );
  }
}

export default WorkInProgressOverlay;
